import { ClassicFormsApi } from '~/api/classic-forms-api';
import { GenericApi, ParamType } from '~/api/generic-api';

export class RestoreBatchApi extends ClassicFormsApi {
	/**
	 * Overriden method to support a non-standard API URL while keeping all the ClassicFormsApi functionality.
	 * @override
	 */
	protected computeClassicFormDataURL(
		functionName: string,
		recordId?: number | string,
	): string {
		return 'api/' + functionName;
	}
}
